import _ from "lodash"
import {migrateConversations} from "./utils"
import {newOrganizationActivities} from "../staticEntities"

const activityIds = newOrganizationActivities.map(activity => activity.id)

const statusByCodeSuffix = {
    SIE: 'headquarters',
    SEC: 'secondary'
}

function migrateCode(shelter, set) {
    const match = /^(.+)-(SIE|SEC)$/.exec(shelter.code || '')
    if (!match) return

    set.previousCode = shelter.code
    set.code = match[1]
    set.status = statusByCodeSuffix[match[2]]
}

const typeAliases = {
    retirementHome: 'retirement'
}

function migrateTypes(shelter, set) {
    if (!Array.isArray(shelter.types) || !shelter.types.some(type => typeAliases[type])) return
    set.types = shelter.types.map(type => typeAliases[type] || type)
}

function migrateCapacityTypes(shelter, capacityTypesByShelterId, set) {
    const capacityTypes = capacityTypesByShelterId.get(shelter._id.toString()) || []
    if (!capacityTypes.length) return
    set.types = _.union(set.types || shelter.types || [], capacityTypes)
}

function buildUpdate(shelter, capacityTypesByShelterId) {
    const set = {country: 'France'}
    migrateCode(shelter, set)
    migrateTypes(shelter, set)
    migrateCapacityTypes(shelter, capacityTypesByShelterId, set)
    migrateConversations(shelter, set)
    return set
}

function buildCapacityTypesByShelterId(capacities) {
    const capacityTypesByShelterId = new Map()

    capacities.forEach(capacity => {
        if (!capacity.shelter) return
        const shelterId = capacity.shelter.toString()
        const activeTypes = activityIds.filter(activityId => Number(capacity[activityId]) > 0)
        if (!activeTypes.length) return

        capacityTypesByShelterId.set(
            shelterId,
            _.union(capacityTypesByShelterId.get(shelterId) || [], activeTypes)
        )
    })

    return capacityTypesByShelterId
}

async function applyJob() {
    const collection = global.app.C.Shelter.collection
    const capacityCollection = global.app.C.Capacity.collection

    const [shelters, capacities] = await Promise.all([
        collection.find({}).toArray(),
        capacityCollection.find({}).toArray()
    ])

    const capacityTypesByShelterId = buildCapacityTypesByShelterId(capacities)

    const operations = shelters.map(shelter => ({
        updateOne: {
            filter: {_id: shelter._id},
            update: {$set: buildUpdate(shelter, capacityTypesByShelterId)}
        }
    }))

    if (!operations.length) return {message: "Aucun établissement à adapter"}

    const result = await collection.bulkWrite(operations)
    return {message: `${result.modifiedCount} établissement(s) adapté(s) sur ${shelters.length}`}
}

export const job = {
    name: "adaptShelterCollection",
    title: "Adapter la collection Shelter au nouveau modèle",
    execute: function(context, callback) {
        applyJob()
            .then(result => callback(null, result))
            .catch(callback)
    }
}
